(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-creative-intelligence"]) return;
  try {
    
  (() => {
    const bytesFromBase64 = (value) => {
      const binary = atob(value);
      return Uint8Array.from(binary, (character) => character.charCodeAt(0));
    };

    const joinBytes = (...values) => {
      const length = values.reduce((total, value) => total + value.length, 0);
      const joined = new Uint8Array(length);
      let offset = 0;
      values.forEach((value) => {
        joined.set(value, offset);
        offset += value.length;
      });
      return joined;
    };

    const decryptPayload = async (payload, password) => {
      const envelope = JSON.parse(new TextDecoder().decode(bytesFromBase64(payload)));
      if (envelope.version !== 1 || envelope.algorithm !== 'AES-256-CBC-HMAC-SHA256') {
        throw new Error('Unsupported encrypted report');
      }
      const salt = bytesFromBase64(envelope.salt);
      const iv = bytesFromBase64(envelope.iv);
      const ciphertext = bytesFromBase64(envelope.ciphertext);
      const expectedMac = bytesFromBase64(envelope.mac);
      const passwordKey = await crypto.subtle.importKey(
        'raw',
        new TextEncoder().encode(password),
        'PBKDF2',
        false,
        ['deriveBits']
      );
      const bits = await crypto.subtle.deriveBits(
        { name: 'PBKDF2', hash: 'SHA-256', salt, iterations: envelope.iterations },
        passwordKey,
        512
      );
      const keyMaterial = new Uint8Array(bits);
      const encryptionKey = await crypto.subtle.importKey(
        'raw',
        keyMaterial.slice(0, 32),
        { name: 'AES-CBC' },
        false,
        ['decrypt']
      );
      const authenticationKey = await crypto.subtle.importKey(
        'raw',
        keyMaterial.slice(32),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['verify']
      );
      const authenticated = await crypto.subtle.verify(
        'HMAC',
        authenticationKey,
        expectedMac,
        joinBytes(salt, iv, ciphertext)
      );
      if (!authenticated) throw new Error('Authentication failed');
      const plaintext = await crypto.subtle.decrypt(
        { name: 'AES-CBC', iv },
        encryptionKey,
        ciphertext
      );
      return new TextDecoder().decode(plaintext);
    };

    const initialize = (root) => {
      if (root.dataset.igciReady === 'true') return;
      root.dataset.igciReady = 'true';
      const form = root.querySelector('[data-igci-form]');
      const input = root.querySelector('[data-igci-password]');
      const button = root.querySelector('[data-igci-submit]');
      const label = root.querySelector('[data-igci-submit-label]');
      const error = root.querySelector('[data-igci-error]');
      const lock = root.querySelector('[data-igci-lock]');
      const content = root.querySelector('[data-igci-content]');
      const payload = root.querySelector('[data-igci-payload]').textContent.trim();
      const buttonText = label.textContent;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        error.hidden = true;
        button.disabled = true;
        root.setAttribute('aria-busy', 'true');
        label.textContent = label.closest('[data-igci-submit]').dataset.loadingLabel;
        try {
          const report = await decryptPayload(payload, input.value);
          content.innerHTML = report;
          content.hidden = false;
          lock.hidden = true;
          root.removeAttribute('aria-busy');
          content.querySelector('h1')?.focus?.();
        } catch (exception) {
          error.hidden = false;
          input.value = '';
          input.focus();
          button.disabled = false;
          label.textContent = buttonText;
          root.removeAttribute('aria-busy');
        }
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-igci-gate]').forEach(initialize);
    };
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
